import { dmApi } from "../../../app/dmApi";
import { serialize } from "../../../helpers/Utils";
import { getAuthorizationHeader, handleQueryError, handleQueryErrorAndSuccess } from "../../../helpers/RtkQueryUtils";

export const managersApi = dmApi.injectEndpoints({
    endpoints: (build) => ({
        searchManagers: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/staff?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['managers'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        createManager: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/staff/create`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['managers'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created", "Manager")
            },
        }),
        getManagerById: build.query({
            query: (id) => {
                return {
                    url: `/staff/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['managerById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        updateManager: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/staff/update/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['managers', 'managersById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Manager")
            },
        }),
        removeManager: build.mutation({
            query: (id) => {
                return {
                    url: `/staff/delete/${id}`,
                    method: 'DELETE',
                    headers: getAuthorizationHeader()
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Removed", "Manager")
            },
            invalidatesTags: ['managers']
        }),
    }),
});


export const {
    useCreateManagerMutation,
    useSearchManagersQuery,
    useUpdateManagerMutation,
    useRemoveManagerMutation
} = managersApi;